import React, { useContext, useCallback} from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import { useParams } from "react-router-dom";
import { DashboardContext } from "../../../contexts/Dashboard/DashboardContext";
import RemoveButton from "../RemoveButton";
import { defaultProps } from "../dataCharts";
import "../styles.css"

const ResponsiveGridLayout = WidthProvider(Responsive);

const Grid = () => {
  const { onLayoutChange, layouts, renderComponent} =
    useContext(DashboardContext);
  const { mode } = useParams();

  const onlyResizeDiagonal = [""]

  const handleResize = useCallback(
    (l, oldLayoutItem, layoutItem, placeholder) => {
      if (onlyResizeDiagonal.includes(layoutItem.i)) {
        const heightDiff = layoutItem.h - oldLayoutItem.h;
        const widthDiff = layoutItem.w - oldLayoutItem.w;
        const changeCoef = oldLayoutItem.w / oldLayoutItem.h;
        if (Math.abs(heightDiff) < Math.abs(widthDiff)) {
          layoutItem.h = layoutItem.w / changeCoef;
          placeholder.h = layoutItem.w / changeCoef;
        } else {
          layoutItem.w = layoutItem.h * changeCoef;
          placeholder.w = layoutItem.h * changeCoef;
        }
      }
    },
    []
  );
  

  return (
    <ResponsiveGridLayout
      {...defaultProps}
      onResize={handleResize}
      className="grid-div"
      isDraggable={mode === "edit"}
      isResizable={mode === "edit"}
      onLayoutChange={onLayoutChange}
    >
      {layouts.map((layout) => (
        <div key={layout.i} data-grid={layout}>
          <RemoveButton layout={layout.i} />
          {renderComponent({ id: layout.i })}
        </div>
      ))}

    </ResponsiveGridLayout>
  );
};

export default Grid;
